import React from 'react';

import { Box } from '@mui/material';

import { ErrorToAllRequests } from '~/components/ErrorToAllRequests';
import { LoaderOverlay } from '~/components/Loader';
import { Page } from '~/components/Page';
import { RequestHeader } from '~/components/RequestHeader';
import { Retry } from '~/components/Retry';
import { useVehicleOptions } from '~/contexts/VehicleOptionsContext';
import { ICamera } from '~/domain/ICamera';
import { useJiraConfigQuery } from '~/hooks/useJiraConfigQuery';
import { useProductConfigurationQuery } from '~/hooks/useProductConfigurationQuery';
import { useRequestQuery } from '~/hooks/useRequestQuery';
import * as LAYOUT from '~/pages/layout';

import { RequestPageBody } from './RequestPageBody';

interface IRequestPage {
  cameras: ICamera[];
  camera?: ICamera;
}

export const RequestPage = React.memo<IRequestPage>(function RequestPage(
  props
) {
  const { camera, cameras } = props;
  const { isError: isJiraConfigError, refetch: refetchJiraConfig } = useJiraConfigQuery();
  const { data: request, isError: isRequestError } = useRequestQuery();
  const {
    data: {
      packSets = [],
      client = '',
    } = {},
    isLoading,
    isError,
  } = useProductConfigurationQuery();
  const { eim } = useVehicleOptions();
  let isMissingAssets = false;

  if (client !== 'subaru') {
    isMissingAssets = (request && request.requestId && !request.addressableRegion)
      || isError
      || (!isLoading && packSets.length < 1);
  } else {
    isMissingAssets = isError || isLoading;
  }

  // console.log('RequestPage ====================')
  // console.log('RequestPage +++++++++++++++ request: ', request)
  // console.log('RequestPage +++++++++++++++ isError: ', isError)
  // console.log('RequestPage +++++++++++++++ isLoading: ', isLoading)
  // console.log('RequestPage +++++++++++++++ isJiraConfigError: ', isJiraConfigError)
  // console.log('RequestPage +++++++++++++++ isRequestError: ', isRequestError)
  // console.log('RequestPage +++++++++++++++ isMissingAssets: ', isMissingAssets)
  // console.log('RequestPage +++++++++++++++ client: ', client)
  // console.log('RequestPage ====================')

  return (
    <Page title={request?.title}>
      <Box sx={[LAYOUT.HEADER]}>
        <RequestHeader />
      </Box>
      <Box
        sx={[LAYOUT.BODY, {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }]}>
        {isJiraConfigError && (
          <Retry retry={refetchJiraConfig} sx={{ margin: 'auto', transform: 'translateY(-50%)' }}>the markets</Retry>
        )}
        {isRequestError && (
          <ErrorToAllRequests maxTextWidth={424}>Sorry, the request you are looking for doesn&apos;t exist.</ErrorToAllRequests>
        )}
        {/* Old Condition */}
        {/* {!isJiraConfigError && !isRequestError && (client !== 'subaru' && isMissingAssets) && (
          <ErrorToAllRequests maxTextWidth={450}>Assets for this request are still in production, please check in later Farg!</ErrorToAllRequests>
        )} */}

        {/* created new condition, old commented out. Keeping JIRA Error and Request Error props. Removed is missing because we are doing 
        partial builds now. Added is loading instead. Common sense says this should not show if ISLOADING===true. kept clint as a check. 
        But client does not get set until 3rd render pass so kept it isolated and last. */}
        {!isJiraConfigError && !isRequestError && !isLoading && (client !== 'subaru') && (
          <ErrorToAllRequests maxTextWidth={450}>Assets for this request are still in production, please check in later</ErrorToAllRequests>
        )}
        {!isJiraConfigError && !isRequestError && !isMissingAssets && (isLoading || (client !== 'subaru' && !eim)) && (
          <LoaderOverlay sx={{ height: '90%' }} />
        )}
        {!isJiraConfigError && !isRequestError && (client === 'subaru' || (!isMissingAssets && !isLoading && (eim))) && (
          <RequestPageBody cameras={cameras} camera={camera} />
        )}
      </Box>
    </Page>
  );
});
